import { render, staticRenderFns } from "./EmailClient.vue?vue&type=template&id=13752a7e"
import script from "./EmailClient.vue?vue&type=script&lang=js"
export * from "./EmailClient.vue?vue&type=script&lang=js"
import style0 from "./EmailClient.vue?vue&type=style&index=0&id=13752a7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports